export default __webpack_public_path__ + "static/img-4-142f0458b23459e0883a44fc42d53497.png";